// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Use your Firebase config from console!

const firebaseConfig = {
  apiKey: "AIzaSyCnN13rJw8VEXsK4awxhDDPk1kk-roAWWA",
  authDomain: "ev-charging-a5c53.firebaseapp.com",
  databaseURL: "https://ev-charging-a5c53-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ev-charging-a5c53",
  storageBucket: "ev-charging-a5c53.firebasestorage.app",
  messagingSenderId: "421525429783",
  appId: "1:421525429783:web:7c531e4f014ff4cb1e0652",
  measurementId: "G-H7DR2CSV6X"
};

const app = initializeApp(firebaseConfig);

// export the auth instance (use this everywhere)
export const auth = getAuth(app);

// Optionally set language, e.g. default device language
// auth.useDeviceLanguage();

export default app;
